import { Box } from "@mui/material";
import { ReactNode, useEffect } from "react";
import { useAutenticacaoContext } from "../../contexts/AutenticacaoContext";
import { useMenuLateralContext } from "../../contexts/MenuLateralContext";
import { useTamanhoTela } from "../../hooks/useTamanhoTela";
import { Header } from "../Header";
import { MenuLateral } from "../MenuLateral";

interface LayoutProps {
    titulo: string;
    children?: ReactNode;
}

export const Layout = ({ titulo, children }: LayoutProps) => {
    const { estabelecimento } = useAutenticacaoContext();
    const { largura } = useMenuLateralContext();
    const { modeloTela } = useTamanhoTela();

    // Sem estabelecimento não há o que navegar (login, seleção de estabelecimento...).
    const exibirMenu = !!estabelecimento;
    const larguraOcupada = exibirMenu && modeloTela === "desktop" ? largura : 0;

    // Elementos fixos fora do fluxo do Layout (barras de ação, alertas) se alinham por esta variável.
    useEffect(() => {
        document.documentElement.style.setProperty("--largura-menu", `${larguraOcupada}px`);
    }, [larguraOcupada]);

    return (
        <>
            {exibirMenu && <MenuLateral />}
            <Header tituloModulo={titulo} exibirMenu={exibirMenu} />
            <Box
                sx={{
                    paddingLeft: `${larguraOcupada}px`,
                    transition: theme => theme.transitions.create("padding-left", { duration: 220 }),
                }}
            >
                {children}
            </Box>
        </>
    );
};
